"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _ProductPrice = _interopRequireDefault(require("@sprinx/react-com/ProductPrice"));

var _ProductPriceElementPriceCvo = _interopRequireDefault(require("../../../components/ProductPriceElementPriceCvo/ProductPriceElementPriceCvo"));

var _useShoppingCurrency = _interopRequireDefault(require("../../../shop/useShoppingCurrency"));

var _usePopulateProductHref = _interopRequireDefault(require("../../../app/AppSettingsProvider/usePopulateProductHref"));

var _ProductDetailDemoProductLinkWarningIcon = _interopRequireDefault(require("./ProductDetailDemoProductLinkWarningIcon"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      '&:hover': {
        textDecoration: 'none'
      }
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      color: theme.palette.text.primary,
      fontWeight: 300
    },
    text: {
      display: 'flex',
      alignItems: 'baseline',
      color: theme.palette.primary.main
    },
    priceText: {
      fontSize: 16,
      fontWeight: 400
    },
    iconContainer: (0, _defineProperty2.default)({
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: theme.spacing(1)
    }, theme.breakpoints.down('sm'), {
      marginRight: theme.spacing(0.5)
    }),
    icon: {
      width: '80%'
    },
    price: {
      marginLeft: theme.spacing(0.5),
      width: 'auto'
    },
    priceElement: {
      fontSize: 21,
      fontWeight: 500
    }
  };
}, {
  name: 'ProductDetailDemoProductLink'
});

function ProductDetailDemoProductLink(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var currency = (0, _useShoppingCurrency.default)();
  var populateProductHref = (0, _usePopulateProductHref.default)();
  var _product$adornments = product.adornments,
      adornments = _product$adornments === void 0 ? [] : _product$adornments;

  var _ref2 = adornments.find(function (i) {
    return i.type === 'demos';
  }) || {},
      _ref2$content = _ref2.content,
      demos = _ref2$content === void 0 ? [] : _ref2$content;

  var demoProduct = demos.length ? populateProductHref(demos[0]) : null;

  if (demoProduct) {
    return /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
      to: demoProduct.href,
      className: (0, _clsx.default)(classes.root, className)
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.iconContainer
    }, /*#__PURE__*/_react.default.createElement(_ProductDetailDemoProductLinkWarningIcon.default, {
      className: classes.icon
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.textContainer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.text
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: classes.priceText
    }, t('productDetailPage/demoProduct/text')), /*#__PURE__*/_react.default.createElement(_ProductPrice.default, {
      product: demoProduct,
      currency: currency,
      className: classes.price
    }, function (_ref3) {
      var priceWithTax = _ref3.priceWithTax;
      return /*#__PURE__*/_react.default.createElement(_ProductPriceElementPriceCvo.default, {
        value: priceWithTax,
        currency: currency,
        className: classes.priceElement
      });
    })), demoProduct.extra && (Array.isArray(demoProduct.extra.additionalNote) && demoProduct.extra.additionalNote.length ? t(demoProduct.extra.additionalNote) : null)));
  }

  return null;
}

process.env.NODE_ENV !== "production" ? ProductDetailDemoProductLink.propTypes = {
  classes: _propTypes.default.shape({
    icon: _propTypes.default.string,
    iconContainer: _propTypes.default.string,
    price: _propTypes.default.string,
    priceElement: _propTypes.default.string,
    priceText: _propTypes.default.string,
    root: _propTypes.default.string,
    text: _propTypes.default.string,
    textContainer: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    adornments: _propTypes.default.array,
    id: _propTypes.default.string.isRequired,
    name: _propTypes.default.arrayOf(_propTypes.default.shape({
      language: _propTypes.default.string.isRequired,
      text: _propTypes.default.string
    })),
    sku: _propTypes.default.string.isRequired
  })
} : void 0;
ProductDetailDemoProductLink.defaultProps = {
  classes: undefined,
  className: undefined,
  product: undefined
};
var _default = ProductDetailDemoProductLink;
exports.default = _default;